import { InvestmentPathType } from "../interfaces/DTO/investmentPathType";

/**
 * פונקציה להמרת קוד מסלול השקעה לשם מוצג
 */
export function formatInvestmentPathType(pathCode: number): string {
  switch (pathCode) {
    case InvestmentPathType.ISRAEL_STOCKS:
      return "מניות ישראל";
    case InvestmentPathType.FOREIGN_STOCKS:
      return "מניות חו\"ל";
    case InvestmentPathType.CORPORATE_INDEXED_BONDS:
      return "אג\"ח קונצרני צמוד";
    case InvestmentPathType.GOVT_INDEXED_BONDS:
      return "אג\"ח ממשלתי צמוד";
    case InvestmentPathType.GOVT_SHEKEL_BONDS:
      return "אג\"ח ממשלתי שקלי";
    case InvestmentPathType.CORPORATE_SHEKEL_BONDS:
      return "אג\"ח קונצרני שקלי";
    case InvestmentPathType.FOREIGN_BONDS:
      return "אג\"ח חו\"ל";
    case InvestmentPathType.FOREIGN_CURRENCY:
      return "מט\"ח";
    case InvestmentPathType.CASH:
      return "מזומנים";
    case InvestmentPathType.STRUCTURED_PRODUCTS:
      return "מוצרים מובנים";
    default:
      return `מסלול לא מוכר (${pathCode})`;
  }
}

/**
 * פונקציה לקבלת צבע לפי סוג מסלול
 */
export function getInvestmentPathColor(pathCode: number): string {
  switch (pathCode) {
    case InvestmentPathType.ISRAEL_STOCKS:
      return "#1976d2"; // כחול
    case InvestmentPathType.FOREIGN_STOCKS:
      return "#0288d1"; // כחול בהיר
    case InvestmentPathType.CORPORATE_INDEXED_BONDS:
      return "#f57c00"; // כתום
    case InvestmentPathType.GOVT_INDEXED_BONDS:
      return "#ff9800"; // כתום בהיר
    case InvestmentPathType.GOVT_SHEKEL_BONDS:
      return "#ffa726"; // כתום עדין
    case InvestmentPathType.CORPORATE_SHEKEL_BONDS:
      return "#fb8c00"; // כתום כהה
    case InvestmentPathType.FOREIGN_BONDS:
      return "#e64a19"; // אדום-כתום
    case InvestmentPathType.FOREIGN_CURRENCY:
      return "#388e3c"; // ירוק
    case InvestmentPathType.CASH:
      return "#43a047"; // ירוק בהיר
    case InvestmentPathType.STRUCTURED_PRODUCTS:
      return "#7b1fa2"; // סגול
    default:
      return "#757575"; // אפור
  }
}
